module.exports = require('./helpers/bundle-url').getBundleURL('6VRlG') + "logo-dark.ba5147f0.svg";